<form nz-form class="form" nzLayout="horizontal" [formGroup]="graphForm">
  <div class="header-with-cta mb-24">
    <h3 class="title s-18">Behavior Intervention Plan</h3>
  </div>
  <div *ngIf="graphData && graphData?.graphList">
    <div *ngFor="let graph of graphControls; let i = index">
      <h3>
        {{ getGraphData(i)?.behaviorCategoryName }} -
        {{ getGraphData(i)?.unitName }}
      </h3>
      <div class="graph-content mb-24" *ngIf="getGraphData(i)">
        <app-frequency-datasheet-graph
          *ngIf="getGraphData(i)?.selectedUnit === 1"
          [graphData]="getGraphData(i)?.data"></app-frequency-datasheet-graph>
        <app-frequency-interval-graph
          *ngIf="
            getGraphData(i)?.intervalData &&
            getGraphData(i)?.selectedUnit === 1 &&
            graphData.showIntervalFrequency &&
            hasFrequencyData(i)
          "
          [graphData]="
            getGraphData(i)?.intervalData
          "></app-frequency-interval-graph>
        <app-latency-graph
          *ngIf="getGraphData(i) && getGraphData(i)?.selectedUnit === 2"
          [graphData]="getGraphData(i)?.data"></app-latency-graph>
        <app-partial-interval-graph
          *ngIf="getGraphData(i) && getGraphData(i)?.selectedUnit === 3"
          [graphData]="getGraphData(i)?.data"></app-partial-interval-graph>
        <app-replacement-behavior-graph
          *ngIf="getGraphData(i) && getGraphData(i)?.selectedUnit === 4"
          [graphData]="getGraphData(i)?.data"></app-replacement-behavior-graph>
        <div
          class="no-graph-data"
          *ngIf="getGraphData(i) && getGraphData(i)?.graphImage?.length === 0">
          No Data for Graph
        </div>
      </div>

      <nz-divider />
      <div formArrayName="graphs">
        <div [formGroup]="graph">
          <nz-form-item class="row-span">
            <nz-form-label nzFor="reportComment">
              Report Comment
            </nz-form-label>
            <nz-form-control>
              <textarea
                id="reportComment"
                name="reportComment"
                rows="4"
                formControlName="comment"
                nz-input
                placeholder="Enter report comment"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div>
  </div>
</form>
